import { Outlet } from 'react-router';

import { FleetNav } from './FleetNav';
import { FleetRouteActions } from './FleetRouteActions';
import { HeaderToolbarAndContentLayout } from 'src/common/primitives/HeaderToolbarAndContentLayout';

export function FleetLayout() {
  return (
    <HeaderToolbarAndContentLayout
      preContent={<FleetNav />}
      actionSection={<FleetRouteActions />}
      content={<Outlet />}
    />
  );
}
